var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 51,
    viewBox: "0 0 41 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: 18,
      height: 16
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3116 0C30.5342 2.90741 29.6148 5.78709 27.7485 8.02752C26.8548 9.13905 25.7206 10.0333 24.4312 10.6429C23.1418 11.2526 21.7309 11.5617 20.3047 11.547C20.2137 10.1489 20.3992 8.7465 20.8505 7.42008C21.3019 6.09366 22.0102 4.86919 22.935 3.81668C24.8265 1.6622 27.4603 0.299466 30.3116 0ZM35.5121 21.1609C34.5645 22.8304 34.0547 24.7125 34.0299 26.632C34.0323 28.7911 34.6701 30.9018 35.8639 32.7009C37.0578 34.5 38.7548 35.9079 40.7434 36.7489C39.9616 39.2888 38.783 41.6891 37.2515 43.8609C35.1946 46.9377 33.038 49.9437 29.6151 49.9992C27.9872 50.0368 26.8884 49.5687 25.7433 49.0809C24.5489 48.5721 23.3043 48.0419 21.3568 48.0419C19.2913 48.0419 17.9909 48.5892 16.7368 49.117C15.6531 49.5731 14.6038 50.0147 13.1251 50.076C9.86538 50.1967 7.37405 46.792 5.24242 43.7441C0.981909 37.5196 -2.33557 26.2025 2.11201 18.502C3.13877 16.6569 4.62596 15.1093 6.42867 14.0099C8.23139 12.9105 10.2882 12.2968 12.3986 12.2286C14.2474 12.1905 16.0214 12.9031 17.5768 13.5279C18.7663 14.0056 19.8279 14.4321 20.6972 14.4321C21.4613 14.4321 22.4933 14.0225 23.696 13.5452C25.5905 12.7933 27.9085 11.8732 30.2708 12.1212C32.0811 12.1778 33.8534 12.6558 35.4467 13.5172C37.04 14.3786 38.4105 15.5996 39.4494 17.0833C37.8141 18.0887 36.4596 19.4914 35.5121 21.1609Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosIcon);
export default __webpack_public_path__ + "static/media/ios-icon.b9b83b43dc3ec678070d2b67ecebc54f.svg";
export { ForwardRef as ReactComponent };